<template>
  <v-app id="inspire">
    <Header type="return"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-10">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">Продажа</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Ресепшен / Рабочий стол / </span> Продажа (список)</div>
                </div>
              </v-col>
              <v-col cols="12">
                <v-data-table
                    :headers="headersSales"
                    :items="listDeals.sales"
                    hide-default-footer
                >
                  <template v-slot:item="{ item }">
                    <tr @click="chooseSale(item.buy.id)" :style="saleChoosed && saleId === item.buy.id ? 'background: #E0ECD6 !important' : 'background: #fff !important'">
                      <td class="text-start">{{ item.date }}</td>
                      <td class="text-start">{{ item.buy.name }}</td>
                      <td class="text-start">{{ item.user.name }}</td>
                      <td class="text-start">{{ item.amount_sale }}</td>
                      <td class="text-start">{{ item.amount_payment}}</td>
                    </tr>
                  </template>
                </v-data-table>
                <v-card-actions
                    class="d-flex justify-end"
                >
                  <button
                      class="button button__success"
                      :style="!saleChoosed ? 'background-color: #F1F1F1 !important; color: #1A1A1A !important;' : ''"
                      :disabled="!saleChoosed"
                      @click="updateSuccess"
                  >
                    Выбрать
                  </button>
                </v-card-actions>
              </v-col>
            </v-row>
          </v-container>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from "@/components/Header";
import Menu from "@/components/Menu";
import {mapState} from "vuex";
import {receptionActionTypes} from "@/store/modules/reception";
import {salesActionTypes} from "@/store/modules/sale";
import {dealsActionTypes} from "@/store/modules/deals";
import {getItem, setItem} from "../helpers/persistanceStorage";

export default {
  name: "SalesNodeal",
  props: ['client','deal'],
  components: {
    Header,
    Menu
  },
  data() {
    return {
      valid: true,
      saleChoosed: false,
      saleId: null,
      headersSales: [
        {text: 'Дата', sortable: false, value: 'date'},
        {text: 'Номер', sortable: false, value: 'number'},
        {text: 'Сумма', sortable: false, value: 'amount_sale'},
        {text: 'Оплачено', sortable: false, value: 'amount_payment'},
        {text: 'Автор', sortable: false, value: 'user.name'},
      ]
    }
  },
  methods: {
    fetchFeed(client_id) {
      this.$store.dispatch(salesActionTypes.getSalesNodeal, {
        client_id
      });
    },
    chooseSale(sale_id) {
      this.saleChoosed = true;
      this.saleId = sale_id;
    },
    updateSuccess() {
      this.$store.dispatch(dealsActionTypes.updateSuccess, {
        deal_id: this.deal,
        buy_id: this.saleId
      }).then((response) => {
        if (response.success) {
          this.$router.push({
            name: 'CardClientNew',
            params: {
              client_id: this.client.client_id
            }
          });
        }
      })
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.sale.isLoading,
      listDeals: state => state.sale.listDeals,
      validationErrors: state => state.reception.validationErrors,
    })
  },
  mounted() {
    this.client !== undefined ? setItem('sale-nodeal-client',this.client) : this.client = getItem('sale-nodeal-client');
    this.deal !== undefined ? setItem('sale-nodeal-deal',this.deal) : this.deal = getItem('sale-nodeal-deal');
    this.fetchFeed(this.client.client_id)
  },
  watch: {
    searchClient() {
      let data = this.searchClient
      this.$store.dispatch(receptionActionTypes.searchClient, { data })
    }
  }
}
</script>

<style scoped>
.new-client {
  border-top: 1px solid #E0E0E0;
  margin: 0 16px 20px 16px;
  padding-top: 20px;
}
.new-client > span {
  margin-top: 20px;
  font-family: 'Circe';
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #629F33;
  cursor: pointer;
}
.payment-text {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
}
.no-data-text {
  font-family: 'Circe';
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  color: #767676;
  padding-left: 16px;
  padding-bottom: 16px;
}
.custom__text-field {
  font-size: 12px;
  font-weight: normal;
  padding: 20px 16px 16px 16px;
}
.custom__select {
  width: 330px;
}
.custom__select.v-select--is-menu-active {
  outline: 4px solid #E0ECD6;
}
.search-service.v-input--is-focused {
  outline: 4px solid #E0ECD6;
}
</style>